<template>
  <b-container>
    <b-row class="cont-back-color">
      <b-col class="text-center">
        <h3 class="p-3">SPONSORSHIP REQUEST</h3>
      </b-col>
    </b-row>
    <div v-if="!isSuccess">
      <b-row class="mt-2 cont-back-color">
        <b-col class="text-center">
          <p class="mt-4">
            Carrier Community is pleased to offer sponsorship opportunities to
            its members helping them to position themselves as the leading
            player in the global telecom village and its market place. These
            opportunities enable also to maximise your company’s brand awareness
            prior and after the GCCM events by being promoted in all Carrier
            Community relevant event’s publications. It also strengthen your
            company’s presence during the event.
            <br />
            <br />We would be glad if you would like to speak to us to discuss
            any questions you have on our interesting and affordable Sponsorship
            opportunities as well as tailored packages.
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-md-center cont-back-color">
        <b-col class="text-center">
          <a
            class="privacy-settings-support-text"
            href="mailto:info@carriercommunity.com?subject=Support&cc=Kara@carriercommunity.com;w.schmidt@carriercommunity.com"
          >
            Need support? Click here!
          </a>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center cont-back-color">
        <b-col>
          <div class="eventBookButtons">
              <a
              class="contact-link"
                href="mailto:info@carriercommunity.com?subject=SPONSORSHIP REQUEST"
                >CONTACT OUR TEAM</a
              >
            <router-link
              :to="{
                name: 'standardEvent',
                params: { eventId: $route.params.eventId, slug: $route.params.slug },
              }"
            >
              <button>CANCEL</button>
            </router-link>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row class="mt-1 cont-back-color">
        <b-col class="text-center">
          <p class="mt-4">
            Thank you for applying!
            <br />Your request will be processed by the CC Team. We will get
            back soon to you!
          </p>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BecomeSponsor',
  data() {
    return {
      isSuccess: false,
    };
  },
  computed: {
    ...mapGetters({
      event: 'events/fetchEvent',
      userInfo: 'user/fetchUserInfo',
    }),
  },
  async mounted() {
    await this.fetchEvent(this.$route.params.eventId);
  },
  methods: {
    ...mapActions({
      fetchEvent: 'events/fetchEvent',
      becomePanelistOrSponsor: 'events/becomePanelistOrSponsor',
    }),
    async reqForSponsor() {
      const data = {
        type: 'sponsor',
        event: this.event.url,
      };
      try {
        await this.becomePanelistOrSponsor(data).then((res) => {
          if (res.status === 200) this.$router.push({ name: 'Messages' });
          // this.isSuccess = true;
        });
      } catch (err) {
        console.log('err', err);
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  padding: 20px 10px;
}
.cont-back-color {
  background-color: white;
}
.eventBookButtons {
  display: flex;
  justify-content: space-between;
  padding: 2% 3%;
}
.eventBookButtons button {
  margin-right: 15px;
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #bd9d5f;
  padding: 4px 8px;
}

.contact-link {
  width: 78%;
  color: white;
  background-color: #bd9d5f;
  border: 1px solid #bd9d5f;
  text-align: center;
  line-height: 32px;
}
.contact-link:hover{
  color: #bd9d5f;
  background-color: white;
}

.eventBookButtons button:hover {
  background-color: #fff;
  color: #bd9d5f;
}

.privacy-settings-support-text {
  margin-top: 20px;
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: center;
  color: #bd9d5f;
}
</style>
